export const LOYALTY_EXCLUDED_GROUP = 'EXCLUDED_FROM_LOYALTY';
